import React from 'react';
import { Button } from '@legalshield/adonis-ux-framework';

import ConfirmationSummary from '../controls/ConfirmationSummary';
import { ConfirmationRenderArgs } from '../QuestionnaireShell';

const ConfirmationView = ({ allValues, onEdit, onBack, onSubmit, submitting }: ConfirmationRenderArgs) => (
  <div>
    <p className="rnq-task-host__description">Please verify your information</p>
    <ConfirmationSummary allValues={allValues} onEdit={onEdit} />
    <div className="rnq-navrow">
      <div className="rnq-navrow__left">
        <Button label="Back" variant="standard" onClick={onBack} />
      </div>
      <div className="rnq-navrow__right">
        <Button label="Submit Application" variant="primary" onClick={onSubmit} disabled={submitting} />
      </div>
    </div>
  </div>
);

const Confirmation = {
  label: 'Review',
  title: 'Application Review',
  render: (args: ConfirmationRenderArgs) => <ConfirmationView {...args} />,
};

export default Confirmation;
